import { render, staticRenderFns } from "./GlobalMarketModal.vue?vue&type=template&id=23b445c0&"
import script from "./GlobalMarketModal.vue?vue&type=script&lang=js&"
export * from "./GlobalMarketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports